import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { RecordContextProvider } from 'react-admin';
import { Box } from 'shared/mui/Box';
import { CardHeader } from 'shared/mui/Card';
import { Dialog, DialogProps } from 'shared/mui/Dialogs';
import { CloseIconButton } from 'shared/mui/IconButtons';
import { MethodsShowChipFields } from 'shared/widgets/MethodsShow/MethodsShowChipFields';
import { MethodsShowSkeleton } from 'shared/widgets/MethodsShow/MethodsShowSkeleton';
import { MethodsShowTable } from 'shared/widgets/MethodsShow/MethodsShowTable';
import { Method } from 'types/embedded/method';

export type MethodsShowDialogProps = {
  method?: Method;
  isFetching?: boolean;
  onClose: () => void;
} & DialogProps;

export const MethodsShowDialog: React.FC<MethodsShowDialogProps> = ({
  open,
  method,
  isFetching,
  onClose,
}) => {
  const translate = useTypedTranslate();

  return (
    <Dialog onClose={onClose} open={open} width="640px">
      <CardHeader
        appendActions={[<CloseIconButton key="close-button" onClose={onClose} />]}
        title={translate('app.methods.details')}
        titleSize="smallBold"
      />
      <Box m={3} mt={2}>
        {isFetching ? (
          <MethodsShowSkeleton />
        ) : (
          <RecordContextProvider value={method}>
            <MethodsShowChipFields />
            <MethodsShowTable />
          </RecordContextProvider>
        )}
      </Box>
    </Dialog>
  );
};
